import axios from "@/plugins/axios";

export function getBlogListByCategoryName(categoryName, pageNum, pageSize) {
  return axios({
    url: `/Article/GetPageList`,
    method: "GET",
    params: {
      categoryName,
      pageIndex: pageNum,
      pageSize,
    },
  });
}

//获取分类页
export function getClassifys(pageIndex, pageSize) {
  return axios({
    url: `Category/GetCategoryList`,
    method: "get",
    params: {
      pageIndex: pageIndex,
      pageSize: pageSize,
    },
  });
}
